import WizardIndicator from './component'
export { WizardIndicator }
export default WizardIndicator